module.exports = __webpack_public_path__ + "img/shape-22.83a2bd9d.png";